import { IFilters } from '../Reports/DashboardVuParams'
import { setVuObjectInfoStore } from '../../Redux/VisualUnits/visualUnitStateSlice'
import {VisualUnitApiDTO_EditSaveVisualUnit} from '../../Interfaces/APIContracts/VisualUnitApiDTO_EditSaveVisualUnit'
import { getVisualUnitParamsIndex } from '../../VisualunitHelpers'
import { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { FoundationsConstants } from '../../FoundationsConstants'
import { useApplyHighlight } from '../../GenericComponents/useApplyHighlight'
const FilterFrame = (props: {
    availFilters: IFilters[]
    vuId: number
    setAvailFilters: any
    setVuObj: any
    objDataFromStore: string
    showUpdateFilterDialog: Function,
    setShowSaveandSaveAs: React.Dispatch<React.SetStateAction<boolean>>
}) => {
    const {
        availFilters,
        vuId,
        setAvailFilters,
        setVuObj,
        objDataFromStore,
        showUpdateFilterDialog,
        setShowSaveandSaveAs
    } = props

    const [draggedItemIndex, setDraggedItemIndex] = useState<number | null>(null)
    const dispatch = useDispatch()
    const {applyHighlight, highlightClass } = useApplyHighlight(FoundationsConstants.APPLY_HIGHLIGHT_DURATION);

    const deleteFilterable = (event: any,filerableIndex: number) => {
        event.stopPropagation()
        let availFilterable = [...availFilters]
        let indexedVuObj: VisualUnitApiDTO_EditSaveVisualUnit[] = [...JSON.parse(objDataFromStore)]
        let _vuIndex = getVisualUnitParamsIndex(vuId, JSON.parse(objDataFromStore))

        availFilterable = availFilterable.filter((_, index) => index !== filerableIndex)

        let addedFilterablePayload = indexedVuObj[_vuIndex].filterable
        addedFilterablePayload = addedFilterablePayload.filter(
            (_: any, index: number) => index !== filerableIndex
        )

        indexedVuObj[_vuIndex].filterable = addedFilterablePayload

        setAvailFilters(availFilterable)
        setVuObj(JSON.stringify(indexedVuObj))
        dispatch(setVuObjectInfoStore({ data: indexedVuObj }))
        setShowSaveandSaveAs(false)
    }

    const handleDragStart = (index: number) => {
        setDraggedItemIndex(index)
    }

    const handleDragOver = (event: React.DragEvent<HTMLLIElement>) => {
        event.preventDefault()
    }

    const previousLengthRef = useRef(availFilters.length);

    useEffect(() => {
        //FP-12106
        const prevLen = previousLengthRef.current;
        const newLen = availFilters.length;
        if (newLen > prevLen) {
            const newIndex = prevLen;
            const id = `add_filter_${newIndex}`;
            setTimeout(() => {
                applyHighlight(id, 'applyHighLight', { autoHide: false });
            }, 0);
        }
        previousLengthRef.current = newLen;
    }, [availFilters.length]);

    const handleDrop = (index: number) => {
        if (draggedItemIndex === null || draggedItemIndex === index) return

        let _vuIndex = getVisualUnitParamsIndex(vuId, JSON.parse(objDataFromStore))

        const reorderedList = [...availFilters]
        let indexedVuObj: VisualUnitApiDTO_EditSaveVisualUnit[] = [...JSON.parse(objDataFromStore)]

        let addedFiltersPayload = [...indexedVuObj[_vuIndex].filterable]
        const [draggedItem] = reorderedList.splice(draggedItemIndex, 1)
        const [draggedPayloadItem] = addedFiltersPayload.splice(draggedItemIndex, 1)

        reorderedList.splice(index, 0, draggedItem)
        addedFiltersPayload.splice(index, 0, draggedPayloadItem)
        
        indexedVuObj[_vuIndex].filterable = addedFiltersPayload

        setVuObj(JSON.stringify(indexedVuObj))
        dispatch(setVuObjectInfoStore({ data: indexedVuObj }))
        setAvailFilters(reorderedList)
        setDraggedItemIndex(null)
    }

    return (
        <ol id={`vu_params_filterables_list_${vuId}`} className="ui-sortable">
            {availFilters &&
                availFilters.map((itr: IFilters, _index: number) => {
                    return (
                        <li key={`filter_item_${_index}`}
                            draggable
                            onDragStart={() => handleDragStart(_index)}
                            onDragOver={handleDragOver}
                            onDrop={() => handleDrop(_index)}
                            id={`vu_params_filterable_${vuId}_${_index}`}
                            className={`ui-sortable-handle ${highlightClass[`add_filter_${_index}`] ?? ""}`}
                            onClick={() =>
                                showUpdateFilterDialog(
                                    vuId,
                                    itr.vuIndex,
                                    false,
                                    true,
                                    'updateFilter',
                                    itr,
                                    _index
                                )
                            }
                        >
                            <div className="logical-operators">
                                <span className="and-operator selected">AND</span>
                                <span className="or-operator not-selected">OR</span>
                            </div>
                            <div className="vu-button ui-state-default ui-corner-all vu-object pos-relative clear-both filterable">
                                <a
                                    id={`vu_params_filterable_delete_${vuId}_${_index}`}
                                    className="vu-object-delete-container"
                                    href="javascript:void(0);"
                                    onClick={(event) => deleteFilterable(event, _index)}
                                >
                                    <span className="vu-object-delete"></span>
                                </a>
                                <div className="filterable-info">{itr.filterableName}</div>
                                <div className="filtervalue-info">{itr.filterableValueDisplay}</div>
                            </div>
                        </li>
                    )
                })}
        </ol>
    )
}

export default FilterFrame
